import { FC, HTMLProps } from 'react';

export const GroupWrappedIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="67"
      height="67"
      viewBox="0 0 67 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.21"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 33.5V41.4939C0 55.5805 11.4195 67 25.5061 67H33.5H41.4939C55.5805 67 67 55.5805 67 41.4939V33.5V25.5061C67 11.4195 55.5805 0 41.4939 0H33.5H25.5061C11.4195 0 0 11.4195 0 25.5061V33.5Z"
        fill="#8280FF"
      />
      <path
        opacity="0.587821"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 26C23 29.3137 25.6863 32 29 32C32.3137 32 35 29.3137 35 26C35 22.6863 32.3137 20 29 20C25.6863 20 23 22.6863 23 26ZM38 32.5C38 34.9853 40.0147 37 42.5 37C44.9853 37 47 34.9853 47 32.5C47 30.0147 44.9853 28 42.5 28C40.0147 28 38 30.0147 38 32.5Z"
        fill="#8280FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.475 35C22.3929 35 16.5824 38.6398 16.001 45.7988C15.9693 46.1888 16.7151 47 17.0913 47H41.8701C42.9969 47 43.0144 46.0932 42.9969 45.8C42.5573 38.4398 36.6568 35 29.475 35ZM51.163 47H45C45 43.6233 43.847 40.5072 41.9013 38.0002L41.9815 38C47.3014 38 51.6721 40.5798 51.9977 46.1C52.0107 46.3199 51.9977 47 51.163 47Z"
        fill="#8280FF"
      />
    </svg>
  );
};
